import classNames from "classnames";
import { Inter } from "next/font/google";

const inter = Inter({ subsets: ["latin"] });

export const InfoTextDesign = ({ children, light }) => (
	<p
		className={classNames(inter.className, {
			"text-gray-400 text-[12px] max-w-96 md:w-fit": light,
			"text-sky-950 text-[13px] font-bold": !light,
			"leading-snug w-full md:w-fit": true,
			"md:text-base": true,
		})}>
		{children}
	</p>
);
